import { render, staticRenderFns } from "./ServiceSettings.vue?vue&type=template&id=678fb752&scoped=true"
import script from "./ServiceSettings.vue?vue&type=script&lang=js"
export * from "./ServiceSettings.vue?vue&type=script&lang=js"
import style0 from "./ServiceSettings.vue?vue&type=style&index=0&id=678fb752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fb752",
  null
  
)

export default component.exports